import { useEffect, useRef, useState } from 'react';

const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(false);
    const throttleInProgress = useRef(false);
    const timeoutId = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const media = window.matchMedia(query);

        const handleResize = () => {
            if (throttleInProgress.current) {
                return;
            }

            throttleInProgress.current = true;
            setMatches(media.matches);

            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }

            timeoutId.current = setTimeout(() => {
                throttleInProgress.current = false;
            }, 50); // Throttle interval: 50ms = 20fps
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);

        return () => {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }

            window.removeEventListener('resize', handleResize);

            // Reset the throttle flag before the component unmounts or updates
            throttleInProgress.current = false;
        };
    }, [query]);

    return matches;
};

export { useMediaQuery };
